module.exports = __webpack_public_path__ + "img/punk7521.26f6708e.png";